import i18n from '~/i18n';

const messagesToast = extra => {
  const value = extra || '';

  const messages = {
    CALLS: {
      callRecording: {
        delete: {
          success: i18n.t(
            'validations.messagesNotifications.calls.callRecording.delete.success'
          ),
          error: i18n.t(
            'validations.messagesNotifications.calls.callRecording.delete.error'
          ),
        },
      },
      tags: {
        edit: {
          success: `Tag ${value} was saved.`,
        },
        assign: {
          success: i18n.t(
            'validations.messagesNotifications.calls.tags.assign.success',
            { tagName: value }
          ),
          error: i18n.t(
            'validations.messagesNotifications.calls.tags.assign.error',
            { tagName: value }
          ),
        },
        new: {
          success: i18n.t(
            'validations.messagesNotifications.calls.tags.new.success'
          ),
        },
        delete: {
          success: i18n.t(
            'validations.messagesNotifications.calls.tags.delete.success'
          ),
        },
      },
      notes: {
        new: {
          success: i18n.t(
            'validations.messagesNotifications.calls.notes.new.success'
          ),
        },
      },
    },
    CONTACTS: {
      new: {
        success: i18n.t(
          'validations.messagesNotifications.contacts.new.success'
        ),
      },
      edit: {
        success: i18n.t(
          'validations.messagesNotifications.contacts.edit.success'
        ),
      },
      newOrg: {
        success: i18n.t(
          'validations.messagesNotifications.contacts.newOrg.success'
        ),
        error: i18n.t(
          'validations.messagesNotifications.contacts.newOrg.error'
        ),
      },
      group: {
        success: i18n.t(
          'validations.messagesNotifications.contacts.group.success'
        ),
      },
    },
    NOTIFICATIONS: {
      network: {
        error: i18n.t(
          'validations.messagesNotifications.notifications.network.error'
        ),
        try: i18n.t(
          'validations.messagesNotifications.notifications.network.try'
        ),
      },
      register: {
        error: i18n.t(
          'validations.messagesNotifications.notifications.register.error'
        ),
        success: i18n.t(
          'validations.messagesNotifications.notifications.register.success'
        ),
        failed: i18n.t(
          'validations.messagesNotifications.notifications.register.failed'
        ),
      },
      call: {
        try: i18n.t('validations.messagesNotifications.notifications.call.try'),
        invalidPhoneNumber: i18n.t(
          'validations.messagesNotifications.notifications.call.invalidPhoneNumber'
        ),
      },
    },
    SYSTEM: {
      microphone: {
        change: {
          success: i18n.t(
            'validations.messagesNotifications.system.microphone.change.success'
          ),
        },
        error: i18n.t(
          'validations.messagesNotifications.system.microphone.error'
        ),
      },
      ringDevice: {
        change: {
          success: i18n.t(
            'validations.messagesNotifications.system.ringDevice.change.success'
          ),
        },
      },
      speaker: {
        change: {
          success: i18n.t(
            'validations.messagesNotifications.system.speaker.change.success'
          ),
        },
      },
      ringTone: {
        change: {
          success: i18n.t(
            'validations.messagesNotifications.system.ringTone.change.success'
          ),
        },
      },
      account: {
        change: {
          success: i18n.t(
            'validations.messagesNotifications.system.account.change.success'
          ),
          error: i18n.t(
            'validations.messagesNotifications.system.account.change.error'
          ),
        },
      },
      callerId: {
        change: {
          success: i18n.t(
            'validations.messagesNotifications.system.callerId.change.success'
          ),
        },
      },
    },
    AUTH: {
      online: i18n.t('validations.messagesNotifications.auth.online'),
      offline: i18n.t('validations.messagesNotifications.auth.offline'),
      password: {
        reset: {
          error: i18n.t(
            'validations.messagesNotifications.auth.password.reset.error'
          ),
        },
      },
    },
    FEEDBACK: {
      success: i18n.t('validations.messagesNotifications.feedback.success'),
      error: i18n.t('validations.messagesNotifications.feedback.error'),
    },
    SETTINGS: {
      language: {
        success: i18n.t(
          'validations.messagesNotifications.settings.language.success'
        ),
      },
      logout: {
        error: i18n.t(
          'validations.messagesNotifications.settings.logout.error'
        ),
      },
    },
    INTEGRATIONS: {
      createContact: {
        error: i18n.t(
          'validations.messagesNotifications.integrations.createContact.error'
        ),
      },
      tickets: {
        onLinkedSuccess: i18n.t(
          'validations.messagesNotifications.integrations.tickets.onLinkedSuccess'
        ),
        onCreatedSuccess: i18n.t(
          'validations.messagesNotifications.integrations.tickets.onCreatedSuccess'
        ),
      },
    },
  };

  return messages;
};

export default messagesToast;
